module.exports = __webpack_public_path__ + "static/gsuite-054c46c722a7049603bf53cf75b80c43.svg";